t = require('app/scripts/views/internal/teacup-with-helpers')('popover_change_user_info')

module.exports = ->
  t.form ->

    t.p '.error', { id: 'account-error' }

    t.div '.field', ->
      t.label { for: 'fullName' }, ->
        t.format 'full-name'
      t.input { id: 'fullName', type: 'text', name: 'fullName', value: t.mustacheVar('fullName') }

    t.div '.field', ->
      t.label { for: 'initials' }, ->
        t.format 'initials'
      t.input { id: 'initials', type: 'text', name: 'initials', value: t.mustacheVar('initials') }

    t.div '.field', ->
      t.label { for: 'username' }, ->
        t.format 'username'
      t.input { id: 'username', type: 'text', name: 'username', value: t.mustacheVar('username'), required: true, autocomplete: 'off', autocorrect: 'off', spellcheck: 'false', autocapitalize: 'off' }

    t.div '.field', ->
      t.label { for: 'bio' }, ->
        t.format 'bio'
      t.textarea { id: 'bio', type: 'text', name: 'bio' }, ->
        t.text t.mustacheVar('bio')

    t.input '.primary.js-save-changes', { type: 'submit', value: t.l('save') }

  t.hr()

  t.p '.quiet.u-bottom', ->
    t.format 'your-initials-are-used-in-place-of-your-avatar-if-your-avatar-is-not-set-usernames-require-a-minimum-of-3-characters-alphanumeric-only'
